<template>
  <div class="memoryTab" @click="outFiltrate">
    <div class="btn">
      <button @click="newMessage">新建{{new_}}</button>
      <button class="butRig" @click="toMergeMemory">合并{{merage}}</button>
      <!--   v-if="merage==='记忆库'"↓ ↓↓↓↓↓↓↓↓-->
      <button class="butRig" v-if="isAlignment" @click="toAlignment">双语对齐</button>
      <button class="statement" @click="goDrill" v-if="nodeName==='drill' && merage==='记忆库' && !role">增量训练</button>
      <searchInput :placeholder="translationMemory" @search="search" @setSearch="setSearch">
      </searchInput>
      <el-popover placement="bottom" width="200" trigger="manual" v-model="visible">
        <el-form class="filterForm" label-position="right" label-width="60px" :model="formLabelAlign">
          <el-form-item label="语言对">
            <el-select v-model="formLabelAlign.lang_desc" placeholder="全部" @change="changeFiltrate">
              <el-option label="全部" value></el-option>
              <el-option v-for="(item,index) in langDescList" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="领域">
            <el-select v-model="formLabelAlign.domain_code" placeholder="全部" @change="changeFiltrate">
              <el-option label="全部" value></el-option>
              <el-option v-for="(item,index) in domainList" :key="index" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button class="sortFiltrate" slot="reference" @click.stop="onFiltrate">
          筛选
          <i class="el-icon--right" :class="iconCaret"></i>
        </el-button>
      </el-popover>
    </div>
    <template>
      <div style="overflow: auto;height:100%">
        <el-table class="myTable" :data="tableData"
          :header-cell-style="{background:'#EAEAEA',color:'#454545',padding:'6.5px 0'}"
          :cell-style="{padding:'11px 0px'}" @sort-change="sortChange" v-loading="loading">
          <template slot="empty">
            <div id="notDate">
              <img src="../../assets/imgs/memory/no_data.png" alt />
              <p>暂无数据，快去创建吧</p>
            </div>
          </template>
          <el-table-column label="序号" min-width="30">
            <template slot-scope="scope">
              <p>
                {{scope.$index + 1}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称" :show-overflow-tooltip="true" min-width="120"></el-table-column>
          <el-table-column prop="langDesc" label="语言对" :show-overflow-tooltip="true" sortable="custom" min-width="93">
          </el-table-column>
          <el-table-column prop="domainName" label="领域" :show-overflow-tooltip="true" min-width="50"></el-table-column>
          <el-table-column prop="sentCount" label="数量" :show-overflow-tooltip="true" min-width="70">
            <template slot-scope="scope">
              <p>{{scope.row.sentCount}}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="128">
            <template slot-scope="scope">
              <div class="operation">
                <el-tooltip class="item pointer" effect="dark" content="查看" placement="bottom">
                  <i class="icon-view" @click="toCheckTab(scope.$index, scope.row,new_)"></i>
                </el-tooltip>
                <el-tooltip class="item pointer" v-if="new_ === '术语库'&&!scope.row.auditStatus" effect="dark"
                  content="审核" placement="bottom">
                  <i class="icon-audit" @click="setAudit(scope.row,scope.$index)"></i>
                </el-tooltip>
                <el-tooltip class="item pointer" effect="dark" content="上传" placement="bottom">
                  <i class="icon-upload" @click="upload(scope.row)"></i>
                </el-tooltip>
                <el-tooltip class="item pointer" effect="dark" content="下载" placement="bottom">
                  <i class="icon-download" @click="getMesBox(scope.$index, scope.row)"></i>
                </el-tooltip>
                <el-tooltip class="item pointer" effect="dark" content="删除" placement="bottom">
                  <i class="icon-delete" @click="handleDelete(scope.$index, scope.row)"></i>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <!-- <div v-if="!$privatization">
            <el-table-column v-if="new_ === '术语库'" prop="auditStatus" label="审核状态" :show-overflow-tooltip="true"
              sortable="custom" min-width="70">
              <template slot-scope="scope">
                {{scope.row.auditStatus==0 ? "未审核" : "审核通过"}}
              </template>
            </el-table-column>
          </div> -->
          <el-table-column prop="createTime" label="创建时间" :show-overflow-tooltip="true" sortable="custom"
            min-width="100">
          </el-table-column>
        </el-table>
      </div>
    </template>
    <messageBox v-if="mesBox" :isShow="mesBox" :tit="tit" :txt="mesTxt" :mesShow="mesShow" :imgSrc="imgSrc1"
      :ifForm="ifForm" @message="showMesBox" @messageIf="messageIf"></messageBox>
    <div class="downloadBox" v-show="isShow">
      <h5>
        {{downloadBoxTit}}
        <span @click="getMesShow">
          <img src="../../assets/imgs/message/popup_close_normal.png" alt />
        </span>
      </h5>
      <div>
        <!-- <i v-for="(item,index) in downloadData" :key="index">
          <img :src="" alt="">
        </i>-->
        <a :href="this.baseURL+'/api/v1/memory/exportMemoryLib?id='+urlId+'&type=tmx'" v-if="downloadBoxTit==='下载记忆库'">
          <i class="tmx">
          </i>
          <span>tmx</span>
        </a>
        <a :href="this.baseURL+'/api/v1/term/exportTermLib?id='+urlId+'&type=tbx'" v-if="downloadBoxTit==='下载术语库'">
          <i class="tbx">
          </i>
          <span>tbx</span>
        </a>
        <a :href="this.baseURL+downloadUrl+urlId+'&type=txt'">
          <i class="txt">
          </i>
          <span>txt</span>
        </a>
        <a :href="this.baseURL+downloadUrl+urlId+'&type=xlsx'">
          <i class="xlsx">
          </i>
          <span>xlsx</span>
        </a>
      </div>
      <p>*点击图标下载</p>
    </div>
    <div class="hide" v-show="isShow"></div>
    <delMessage :isShow="isdelMessage" :txt="delTxt" :interpreterBut="interpreterBut"></delMessage>
  </div>
</template>

<script>

import messageBox from "@/common/messageBox.vue";
import delMessage from "@/common/delMessage.vue";
import { setInterval, clearInterval } from "timers";
import searchInput from "@/common/searchInput.vue";
export default {
  name: "memoryTab",
  props: ["new_", "merage", "tableData"],
  components: {
    messageBox,
    delMessage,
    searchInput
  },
  data () {
    return {
      mesBox: false,
      imgSrc1: require("../../assets/imgs/memory/popup_background.png"),
      isShow: false,
      mesShow: "",
      mesTxt: "",
      downloadBoxTit: "",
      downloadData: [
        { name: "tmx", src: "" },
        { name: "txt", src: "" },
        { name: "xlsx", src: "" }
      ],
      search_mod: "",
      ifForm: "",
      tit: "",
      delIndex: "",
      isdelMessage: false,
      delTxt: "",
      interpreterBut: "",
      url: "",
      rowsId: "", // 用来删除
      rowsIndex: "", // 用来审核
      delUrl: "",
      loading: true,
      opp: "",
      projectId: "",
      downloadUrl: "",
      urlId: "",
      timeOut: false,
      updateUrl: "",
      visible: false,
      formLabelAlign: {
        domain_code: "",
        lang_desc: ""
      },
      domainList: [],
      langDescList: [],
      iconCaret: "el-icon-caret-bottom",
      tableHeight: window.innerHeight * 0.675,
      nodeName: ""
    };
  },

  created () {
    this.$store.commit("setmyTemplate", this.new_);
    this.nodeName = process.env.VUE_APP_NAME;
    // console.log(this.tableData, "this.tableData.length");
    let myUser = localStorage.getItem("myUser");
    myUser = JSON.parse(myUser); //把字符串转换成JSON对象
    const lastSelectCompany = JSON.parse(localStorage.lastSelectCompany)
    this.role = lastSelectCompany.role;
    if (this.merage === "记忆库") {
      this.delUrl = "/api/v1/memory/deleteTransMemoryLib";
      this.updateUrl = "/api/v1/memory/querySentCount";
    } else {
      this.delUrl = "/api/v1/term/deleteTransTermLib";
      this.updateUrl = "/api/v1/term/querySentCount";
    }
    // this.roe();
    // console.log(this.$store.state.newForm);
  },
  updated () {
    // console.log(this.tableData, "this.tableData.length");
    if (this.tableData) {
      this.loading = false;
    }
  },
  computed: {
    translationMemory () {
      return "输入翻译" + this.new_
    },
    isAlignment () {
      if (process.env.VUE_APP_NAME === "school" && process.env.VUE_APP_INDEPENDENCE==="1") {
        return this.merage === "记忆库"
      } else {
        return false
      }
    },
  },
  mounted () {
    // alert("11");
    // if (!this.teme) {
    //     // alert("00")
    //     let ary = [];
    //     this.tableData.forEach(item => {
    //       if (item.status === 2) {
    //         ary.push(item.id);
    //       }
    //     });
    //     console.log(ary);
    // var p = 0;
    // }
  },
  watch: {
    // 监测状态
    tableData () {
      var that = this;
      this.timeOut = setInterval(() => {
        let ary = [];
        let status = true;
        that.tableData.forEach(item => {
          if (item.status === 2) {
            ary.push(item.id);
            status = false;
          }
        });
        if (!status) {
          this.catReq1Service(this.updateUrl, { idList: ary }, "post", 2).then(function (response) {
            if (!response.success) {
              return;
            }
            response.result.forEach(i => {
              that.tableData.forEach(item => {
                if (item.id === i.id) {
                  item.status = i.status;
                  item.sentCount = i.sentCount || 0;
                  if (item.status === 2) {
                    item.sentCount = "正在统计中...";
                  }
                }
              });
            });
          });
        } else {
          that.clear();
        }
      }, 2000);
    }
  },
  beforeDestroy () {
    clearInterval(this.timeOut);
  },
  methods: {
    setSearch (data) {
      this.search_mod = data;
    },
    //  双语对齐
    toAlignment () {
      this.$router.push({ name: "alignment" })
    },
    goDrill () {
      this.$router.push({ name: "drill" })
    },
    changeFiltrate () {
      let obj = this.formLabelAlign;
      obj.name = this.search_mod.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
      this.$emit("search", obj);
    },
    // 关闭筛选
    outFiltrate () {
      if (this.visible) {
        this.visible = false;
        let obj = this.formLabelAlign;
        obj.name = this.search_mod.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
        this.iconCaret = "el-icon-caret-bottom"
        this.$emit("search", obj);
      }
    },
    // 筛选
    onFiltrate () {
      this.visible = !this.visible;
      if (!this.visible) {
        let obj = this.formLabelAlign;
        obj.name = this.search_mod.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
        this.iconCaret = "el-icon-caret-bottom"
        this.$emit("search", obj);
      } else {
        this.formLabelAlign = {
          domain_code: "",
          lang_desc: ""
        }
        this.iconCaret = "el-icon-caret-top";
        this.getDomainList();
        this.getLangDescList();
      }
    },
    // 获取领域列表
    getDomainList () {
      var that = this;
      let url;
      if (this.merage === "记忆库") {
        url = "/api/v1/memory/queryDomainList";
      } else {
        url = "/api/v1/term/queryDomainList";
      }
      this.catReq1Service(url).then(function (response) {
        if (!response.success) {
          return;
        }
        that.domainList = response.result;
      });
    },
    // 获取语言对列表
    getLangDescList () {
      var that = this;
      let url;
      if (this.merage === "记忆库") {
        url = "/api/v1/memory/queryLangDescList";
      } else {
        url = "/api/v1/term/queryLangDescList";
      }
      this.catReq1Service(url).then(function (response) {
        if (!response.success) {
          return;
        }
        that.langDescList = response.result;
      });
    },
    clear () {
      clearInterval(this.timeOut);
    },
    // 排序
    sortChange ({ column, prop, order }) {
      // console.log(prop);
      if (order == "descending") {
        order = "desc";
      } else if (order == "ascending") {
        order = "asc";
      }
      if (prop == "createTime") {
        // 时间
        this.sort = { create_time: order };
        this.$emit("goSort", { create_time: order });
        // // debugger
        // this.sort = { create_time: order };
        // this.$parent.getPage(this.currentPage, this.search_mod, {
        //   create_time: order
        // });
      } else {
        // 语言对
        this.sort = { lang_desc: order };
        this.$emit("goSort", { lang_desc: order });
        // this.sort = { lang_desc: order };
        // this.$parent.getPage(this.currentPage, this.search_mod, {
        //   lang_desc: order
        // });
      }
    },
    // 合并记忆库
    toMergeMemory () {
      this.$router.push({
        path: "/home/memory/mergeMemory",
        query: { merage: this.merage }
      });
    },
    upload (row) {
      var that = this;
      that.projectId = row.id;
      that.tit = "上传" + that.new_;
      that.mesShow = "1",
        that.ifForm = "2";
      this.mesTxt = '';
      if (that.mesBox) {
        that.mesBox = false;
      } else {
        that.mesBox = true;
      }
    },
    // 搜索
    search () {
      let obj = this.formLabelAlign;
      obj.name = this.search_mod.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
      this.$emit("search", obj);
    },
    // 查看
    toCheckTab (index, row, new_) {
      // console.log(row);
      if (row.status === 2) {
        this.$message.closeAll();
        this.$message({
          message: `${this.merage}条目正在解析中，无法查看，请稍后再试`,
          type: "warning"
        });
        return;
      }
      var name = row.name;
      var id = row.id;
      this.$router.push({
        path: "/home/memory/checktab",
        query: {
          key: this.$Base64.encode(
            JSON.stringify({
              rowName: name,
              checkTxt: new_,
              rowId: id,
              // sentCount: row.sentCount,
              langDesc: row.langDesc
            })
          )
        }
      });
    },
    download (data, str) {
      if (!data) {
        return;
      }
      let url = window.URL.createObjectURL(new Blob([data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", `${response.headers["filename"]}.${str}`);
      document.body.appendChild(link);
      link.click();
    },
    // 下载
    getMemory (str) {
      var that = this;
      var url;
      if ((that.downloadBoxTit = "下载记忆库")) {
        url = `/api/v1/memory/exportMemoryLib?id=${this.opp}&type=${str}`;
      } else {
        url = `/api/v1/term/exportTermLib?id=${this.opp}&type=${str}`;
      }
      this.isShow = false;
    },
    // 下载弹窗关闭
    getMesShow () {
      this.isShow = false;
    },
    // 下载弹窗
    getMesBox (index, row) {
      var that = this;
      // if (row.status === 2) {
      //   that.isdelMessage = true;
      //   that.delTxt = "记忆库正在解析中，无法下载，请稍后重试";
      //   that.interpreterBut = true;
      //   return;
      // }
      if (row.status === 2) {
        this.$message.closeAll();
        this.$message({
          message: `${this.merage}条目正在解析中，无法下载，请稍后再试`,
          type: "warning"
        });
        return;
      }
      if (row.sentCount === 0) {
        that.isdelMessage = true;
        that.delTxt = `${this.merage}明细为空，无法下载，请添加明细后重试`;
        that.interpreterBut = true;
        return;
      }
      that.isShow = true;
      that.opp = row.id;
      that.urlId = row.id;
      if (that.new_ == "记忆库") {
        that.downloadBoxTit = "下载记忆库";
        this.downloadUrl = "/api/v1/memory/exportMemoryLib?id=";
      } else {
        that.downloadBoxTit = "下载术语库";
        this.downloadUrl = "/api/v1/term/exportTermLib?id=";
      }
    },
    // 弹窗确定键事件
    showMesBox (data) {
      // console.log("99999999999999")
      let that = this;
      if (this.tit === "审核") {
        this.catReq1Service("/api/v1/term/updated_transTerm_status", { idList: [that.tableData[that.rowsIndex].id] })
          .then(function (response) {
            if (!response.success) {
              return;
            }
            that.$set(that.tableData[that.rowsIndex], "auditStatus", 1);
            that.$message.closeAll();
            that.$message({
              message: "审核通过",
              type: "success"
            });
            that.mesBox = false;
          });
        return
      }
      let params = that.$store.state.newForm;
      if (params.sentFileUrlList.length <= 0) {
        this.$message.closeAll();
        that.$message({
          message: "请先上传文件!",
          type: "warning"
        });
        return;
      }
      if (this.tit === "新建记忆库" || that.tit === "新建术语库") {
        params.name = params.name.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");

        if (!this.detection(params.name)) {
          return;
        }
        if (params.sourceLang == "" || params.targetLang == "") {
          this.$message.closeAll();
          that.$message({
            message: "请选择语言!",
            type: "warning"
          });
          return;
        }
        if (params.domainCode == "") {
          this.$message.closeAll();
          that.$message({
            message: "请选择领域!",
            type: "warning"
          });
          return;
        }
        if (params.sourceLang === params.targetLang) {
          this.$message.closeAll();
          that.$message({
            message: "请选择不同的语言对!",
            type: "warning"
          });
          return;
        }
      } else {
        // 列表中的上传
        params = {
          id: that.projectId,
          sentFileUrlList: params.sentFileUrlList,
        };
      }
      let ary = [];
      // that.$store.commit("setNewForm", ary);
      that.mesBox = false;
      if (that.new_ == "记忆库") {
        this.catReq1Service("/api/v1/memory/addTransMemoryLib", params)
          .then(function (response) {
            if (!response.success) {
              return;
            }
            // that.$store.commit("removeSentFileUrl");
            that.$store.dispatch("disRemoveSentFileUrl");
            that.$parent.getPage("1");
          });
      } else {
        this.catReq1Service("/api/v1/term/addTransTermLib", params)
          .then(function (response) {
            if (!response.success) {
              return;
            }
            that.$store.dispatch("disRemoveSentFileUrl");
            that.$parent.getPage("1");
          });
      }
    },
    // 审核弹窗
    setAudit (row, index) {
      this.tit = '审核';
      this.ifForm = "0";
      this.mesShow = '0';
      this.mesTxt = '确认本术语库审核通过？审核通过的术语可以自动挂载到后续语言对一致的项目中了';
      this.mesBox = true;
      this.rowsIndex = index;
    },
    // 新建库弹窗
    newMessage () {
      this.tit = "新建" + this.new_;
      this.ifForm = "1";
      this.mesShow = '1';
      this.mesTxt = '';
      this.mesBox = true;
    },
    // 弹窗取消键
    messageIf () {
      this.mesBox = false;
    },
    /* 删除开始  */
    call () {
      this.isdelMessage = false;
    },
    del () {
      var that = this;
      // that.tableData.splice(that.delIndex, 1);
      this.loading = true;
      var params = {
        id: that.rowsId,
        userType: 1
      };
      this.catReq1Service(this.delUrl, params).then(function (response) {
        if (!response.success) {
          return;
        }
        that.isdelMessage = false;
        that.loading = false;
        that.$emit("goSort", that.sort);
      });
    },
    handleDelete (index, rows) {
      var that = this;
      // if (rows.status === 2) {
      //   that.isdelMessage = true;
      //   that.delTxt = "记忆库正在解析中，无法删除，请稍后重试";
      //   that.interpreterBut = true;
      //   return;
      // }
      if (rows.status === 2) {
        this.$message.closeAll();
        this.$message({
          message: `${this.merage}条目正在解析中，无法删除，请稍后再试`,
          type: "warning"
        });
        return;
      }
      that.rowsId = rows.id;
      that.delIndex = index;
      that.isdelMessage = true;
      that.interpreterBut = false;
      that.delTxt = "删除该" + that.new_ + "条目吗？";
    },
    /* 删除结束  */
    // 获取table数据
    getTab () {
      this.catReq1Service("/user", {
        ID: 12345
      }, "get")
        .then(function (response) {

        });
    }
  }
};
</script>
<style lang="less" >
</style>
<style lang="less" scoped>
.memoryTab {
  height: calc(100% - 70px);
  // width: 1620px;
  position: relative;
  // height: 550px;
  // 下载弹窗
  .hide {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 1);
    opacity: 0.7;
    z-index: 888;
  }
  .downloadBox {
    width: 450px;
    height: 290px;
    box-sizing: border-box;
    padding: 0 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(76, 76, 76, 0.8);
    border-radius: 10px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    opacity: 1;
    h5 {
      // width: 450px;
      height: 48px;
      line-height: 48px;
      // background: rgba(177, 178, 178, 1);
      border-radius: 10px 10px 0px 0px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #454545;
      position: relative;

      border-bottom: 1px solid #dfe4e8;
      span {
        position: absolute;
        right: 10px;
        img {
          cursor: pointer;
          -webkit-transition: -webkit-transform 0.6s ease-out;
          -moz-transition: -moz-transform 0.6s ease-out;
          transition: transform 0.6s ease-out;
        }
        img:hover {
          -webkit-transform: rotate(180deg);
          -moz-transform: rotate(180deg);
          transform: rotate(180deg);
        }
      }
    }
    div {
      margin: 70px 0px auto;
      a {
        margin: 0 25px;
        width: 34px;
        text-align: center;
        display: inline-block;
      }
      i {
        width: 20px;
        height: 26px;
        vertical-align: middle;
        display: inline-block;
        cursor: pointer;
      }
      i:nth-child(1) {
        margin-left: 0px;
      }

      .tbx {
        background: url("../../assets/imgs/memory/tbx.png");
      }
      .tmx {
        background: url("../../assets/imgs/memory/tmx.png");
      }
      .txt {
        background: url("../../assets/imgs/memory/txt.png");
      }
      .xlsx {
        background: url("../../assets/imgs/memory/xlsx.png");
      }
      // .tbx:hover {
      //   background: url("../../assets/imgs/memory/tbx_hover.png");
      // }
      // .tmx:hover {
      //   background: url("../../assets/imgs/memory/hover_tmx.png");
      // }
      // .txt:hover {
      //   background: url("../../assets/imgs/memory/hover_txt.png");
      // }
      // .xlsx:hover {
      //   background: url("../../assets/imgs/memory/hover_xlsx.png");
      // }
      // .tmx:active {
      //   background: url("../../assets/imgs/memory/press_tmx.png");
      // }
      // .txt:active {
      //   background: url("../../assets/imgs/memory/press_txt.png");
      // }
      // .xlsx:active {
      //   background: url("../../assets/imgs/memory/press_xlsx.png");
      // }
      // .tbx:active {
      //   background: url("../../assets/imgs/memory/tbx_press.png");
      // }
    }
    p {
      position: absolute;
      bottom: 29px;
      left: 30px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }
  }
  // 下载弹窗 结束
  // 表格样式开始
  /deep/.el-table {
    .el-table__empty-block {
      // 修改无数据 出现滚动条
      height: 90% !important;
    }
  }
  /deep/.el-table {
    height: 100%;
    margin: 0px auto;
    /deep/.row-expand-cover .el-table__expand-icon {
      visibility: hidden;
    }

    th {
      text-align: center !important;
    }
    /deep/.el-table__expanded-cell {
      padding: 0;
      padding-left: 20px;
      border-bottom: 0px;
    }
    /deep/.el-table__expanded-cell:hover {
      background: #fff !important;
    }
    .el-table__body-wrapper {
      height: calc(100% - 47px);
      overflow-y: auto;
      background: #f5f4f4;
    }
  }
  /deep/.el-table td {
    border-bottom: 1px solid #e7e7e7 !important;
  }
  /deep/.el-table::before {
    height: 0px;
  }
  /deep/.el-table th.is-leaf {
    border-bottom: 0px;
  }

  /deep/ .el-table--enable-row-hover .el-table__body tr {
    background: #f5f4f4;
  }

  /deep/.el-table td {
    // border-bottom: 20px solid #ffff;
    text-align: center;
    font-size: 12px;
  }
  /deep/.el-table th:nth-child(2) {
    text-align: left !important;
  }
  /deep/.el-table td:nth-child(2) {
    text-align: left !important;
    .cell {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  //   /deep/.el-table .el-table .el-table  td:nth-child(2) {
  //     text-align: center;
  //   }
  /deep/.el-table--enable-row-hover .el-table__body tr:hover {
    //   box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5);
    .operation {
      display: block;
    }
  }
  /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    // table 鼠标滑动效果
    background: rgba(210, 210, 210, 1);
  }
  #notDate {
    // 暂无数据
    // margin-top: 80px;
  }
  .el-table {
    color: #333333;
    .operation {
      // display: flex;
      display: none;
      justify-content: center;
      i {
        display: inline-block;
        margin: 0 7px;
        width: 20px;
        height: 18px;
      }
      .icon-view {
        background: url("../../assets/imgs/memory/see_normal.png") no-repeat;
      }
      .icon-view:active {
        background: url("../../assets/imgs/memory/see_press.png") no-repeat;
      }
      .icon-audit {
        background: url("../../assets/imgs/memory/submission_normal.png")
          no-repeat;
      }
      .icon-audit:active {
        background: url("../../assets/imgs/memory/submission_press.png")
          no-repeat;
      }
      .icon-upload {
        background: url("../../assets/imgs/memory/upload_normal.png") no-repeat;
      }
      .icon-upload:active {
        background: url("../../assets/imgs/memory/upload_press.png") no-repeat;
      }
      .icon-download {
        background: url("../../assets/imgs/memory/download_normal.png")
          no-repeat;
      }
      .icon-download:active {
        background: url("../../assets/imgs/memory/download_press.png") no-repeat;
      }
      .icon-delete {
        background: url("../../assets/imgs/memory/delete_normal.png") no-repeat;
      }
      // .icon-delete:hover {
      //   background: url("../../assets/imgs/memory/delete_hover.png") no-repeat;
      // }
      .icon-delete:active {
        background: url("../../assets/imgs/memory/delete_press.png") no-repeat;
      }
    }
  }
  // 表格样式结束
  .btn {
    // left: 50%;
    // top: 550px;
    // transform: translate(-50%, 0);
    margin-bottom: 10px;
    position: relative;
    height: 38px;
    .statement {
      float: right;
      margin-left: 20px;
    }
    span {
      float: right;
      margin-right: 20px;
      .sortFiltrate {
        float: right;
        width: 100px;
        height: 36px;
        line-height: 0px;
        color: black;
        border: 0px;
        background: #f5f4f4;
      }
    }
    button {
      cursor: pointer;
      float: left;
      width: 92px;
      height: 32px;
      line-height: 32px;
      background: #5256e9;
      border-radius: 4px;
      color: rgba(255, 255, 255, 1);
      border: 0px;
      position: relative;
      top: 2px;
    }
    // button:nth-child(1){
    //   float: left;
    // }
    .butRig {
      background: #767af5;
      margin-left: 20px;
    }
    button:active {
      // background: rgba(224, 237, 252, 1);
      // color: rgba(87, 122, 188, 1);
      // border: 1px solid rgba(87, 122, 188, 1);
    }
    .butRig:active {
      // background: rgba(85, 122, 188, 1);
      // color: rgba(255, 255, 255, 1);
    }
    button:hover {
      // background: rgba(201, 213, 226, 1);
      // border: 1px solid rgba(57, 139, 241, 1);
    }
    .butRig:hover {
      // background: rgba(51, 125, 216, 1);
    }
  }
}
/deep/.el-select .el-input {
  width: 100%;
}
.filterForm {
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>
